import { useTranslations } from 'next-intl';
import { EnergyLabelTextLabel, EnergyLabelContainer } from '@atoms/EnergyLabel/EnergyLabel.styles';
import Image from 'next/image';
import { EnergyDeclaration } from '@occ/api-client';

export interface EnergyLabelProps {
  energyDeclaration: EnergyDeclaration;
  onClick?: () => void;
  size?: 'large' | 'small';
}

const getEnergyDeclarationArrowImageUrl = (grade: EnergyDeclaration['value']) =>
  grade ? `/images/${grade.toUpperCase()}.png` : undefined;

const EnergyLabel = ({ energyDeclaration, onClick, size = 'small' }: EnergyLabelProps) => {
  const t = useTranslations('product');

  const imageUrl = getEnergyDeclarationArrowImageUrl(energyDeclaration.value);
  if (!imageUrl) {
    return null;
  }

  const altTextKeys: Record<
    string,
    | 'energyDeclaration.altText.A'
    | 'energyDeclaration.altText.B'
    | 'energyDeclaration.altText.D'
    | 'energyDeclaration.altText.E'
    | 'energyDeclaration.altText.F'
    | 'energyDeclaration.altText.G'
  > = {
    A: 'energyDeclaration.altText.A',
    B: 'energyDeclaration.altText.B',
    D: 'energyDeclaration.altText.D',
    E: 'energyDeclaration.altText.E',
    F: 'energyDeclaration.altText.F',
    G: 'energyDeclaration.altText.G',
  };

  const altTextKey = energyDeclaration.value?.toUpperCase();
  const altText = altTextKey && altTextKey in altTextKeys ? t(altTextKeys[altTextKey]) : '';

  return (
    <EnergyLabelContainer>
      <Image
        unoptimized
        data-testid="energy-label-image"
        src={imageUrl}
        width={size === 'large' ? 111 : 73}
        height={size === 'large' ? 66 : 44}
        onClick={onClick}
        style={{ cursor: Boolean(onClick) ? 'pointer' : 'default', display: 'block' }}
        alt={altText}
      />
      <EnergyLabelTextLabel target="_blank" href={energyDeclaration.link as string}>
        {t('label.energy_label')}
      </EnergyLabelTextLabel>
    </EnergyLabelContainer>
  );
};

export default EnergyLabel;
